import React, { FC } from 'react';

import styles from './PopoverContent.scss';

const PopoverContentSeparator: FC = () => (
  <div key="separator" role="separator" className={styles.separator} />
);

export default PopoverContentSeparator;
